import React from 'react';
import classNames from 'classnames';
import { Badge } from 'reactstrap';
import { matchPath, NavLink, useLocation } from 'react-router-dom';
import { MenuBadge } from './MenuBadge';
import { Icon as IconType } from 'react-feather';

interface Props {
  navLink: string;
  icon: IconType;
  title: string;
  badge?: MenuBadge;
  disabled?: boolean;
}

const VerticalNavMenuLink: React.FC<Props> = ({
  navLink,
  icon,
  title,
  badge,
  disabled = false,
}) => {
  const location = useLocation();
  const currentURL = location.pathname;
  const Icon = icon;

  const itemMatch = matchPath(currentURL, {
    path: `${navLink}`,
    exact: false,
    strict: false,
  });

  const isActive = itemMatch?.url === navLink;

  return (
    <li
      className={classNames({
        'nav-item': true,
        disabled,
        active: isActive,
      })}
    >
      <NavLink
        className="d-flex align-items-center"
        to={navLink}
        isActive={() => isActive}
      >
        <Icon className="mb-px" />
        <span
          className="menu-item text-truncate"
          style={{ lineHeight: 'normal' }}
        >
          {title}
        </span>

        {!!badge && (
          <Badge className="ml-auto mr-1" color={badge.color || 'danger'} pill>
            {badge.text}
          </Badge>
        )}
      </NavLink>
    </li>
  );
};

export default VerticalNavMenuLink;
